import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormResponse } from 'src/models/form-response';
import { User } from 'src/models/user';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  private apiURL = '/account';

  public loggedInUser = new BehaviorSubject<User>(undefined);

  constructor(private httpClient: HttpClient) {
    this.getUser().subscribe((user: User) => {
      this.loggedInUser.next(user);
    });
  }

  public signup(inEmail: string, inPassword: string, inCaptcha: string): Observable<FormResponse> {
    return this.httpClient.post<object>(this.apiURL + '/registration/signup', {
      email: inEmail,
      pwd: inPassword,
      captcha: inCaptcha
    }).pipe(map(res => {
      const formResponse = new FormResponse(res);

      return formResponse;
    }));
  }

  public confirm(email: string, confirmKey: string): Observable<FormResponse> {
    return this.httpClient.post<object>(this.apiURL + '/registration/confirm', {
      email: email,
      regkey: confirmKey
    }).pipe(map(res => {
      const formResponse = new FormResponse(res);

      return formResponse;
    }));
  }

  public isPasswordChangeAllowed(email: string, resetKey: string): Observable<boolean> {
    return this.httpClient.post<object>(this.apiURL + '/registration/resetAllowed', {
      email: email,
      regkey: resetKey
    }).pipe(map(res => {
      const formResponse = new FormResponse(res);

      return formResponse.result;
    }));
  }

  public changePassword(email: string, password: string, resetHash: string): Observable<FormResponse> {
    return this.httpClient.post<object>(this.apiURL + '/registration/changePassword', {
      email: email,
      pwd: password,
      regkey: resetHash
    }).pipe(map(res => {
      const formResponse = new FormResponse(res);

      return formResponse;
    }));
  }

  public changeOldPassword(oldPassword: string, newPassword: string): Observable<FormResponse> {
    return this.httpClient.post<object>(this.apiURL + '/auth/changePassword', {
      oldPwd: oldPassword,
      newPwd: newPassword
    }).pipe(map(res => {
      const formResponse = new FormResponse(res);

      return formResponse;
    }));
  }

  public resetPassword(inEmail: string, inCaptcha: string): Observable<FormResponse> {
    return this.httpClient.post<object>(this.apiURL + '/registration/reset', {
      email: inEmail,
      captcha: inCaptcha
    }).pipe(map(res => {
      const formResponse = new FormResponse(res);

      return formResponse;
    }));
  }

  public login(inEmail: string, inPassword: string, inCaptcha: string): Observable<FormResponse> {
    return this.httpClient.post<object>(this.apiURL + '/auth/authenticate', {
      email: inEmail,
      pwd: inPassword,
      captcha: inCaptcha
    }).pipe(map(res => {
      const formResponse = new FormResponse(res);

      if (formResponse.result === true) {
        const user = new User();
        user.id = formResponse.data['user']['id'];
        user.email = formResponse.data['user']['email'];

        this.loggedInUser.next(user);
      } else {
        this.loggedInUser.next(undefined);
      }

      return formResponse;
    }));
  }

  public logout(): Observable<boolean> {
      return this.httpClient.get<object>(`${this.apiURL}/auth/logout`).pipe(map(res => {
        const formResponse = new FormResponse(res);

        this.loggedInUser.next(undefined);

        return formResponse.result;
    }));
  }

  public getUser(): Observable<User> {
    return this.httpClient.get<object>((`${this.apiURL}/auth/getUser`)).pipe(map(res => {
        const formResponse = new FormResponse(res);

        if (!formResponse.result) {
          return undefined;
        }

        const user = new User();
        user.id = formResponse.data['user']['id'];
        user.email = formResponse.data['user']['email'];

        return user;
    }));
  }
}
